export const getModalStatus = store => store.auth.showModal;
export const getUser = store => store.auth.user;
export const getAccessToken = store => store.auth.accessToken;
export const getRefreshToken = store => store.auth.refreshToken;
export const getLoadingStatus = store => store.auth.isLoading;
export const getErrorStatus = store => store.auth.isError;
export const getLoginStatus = store => store.auth.isLogin;
export const getDailyIntake = store => store.auth.dailyDiet;
export const getUserDailyDiet = store => store.auth.userDailyDiet;
export const getEmailStatus = store => store.auth.emailStatus;
export const gettEmailOnCheck = store => store.auth.emailOnCheck;
export const getKeyStatus = store => store.auth.keyStatus;
export const getPasswordStatus = store => store.auth.passwordStatus;
export const getRegistrationStatus = store => store.auth.registrationStatus;
